export const gruposBreadcrumbItems = [
  { label: "Cadastros", to: "/cadastros" },
  {
    label: "Grupos de Acesso",
    active: true,
  }
];